import * as React from "react";
import { useState } from "react";
import { ODataParams, Query } from "../../Components/Query";
import DocumentTitle from "../../misc/components/DocumentTitle";
import { StudiesTable } from "./StudiesTable";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";

export const StudiesList = () => {
    const client = useWebPortalApiClient();

    const handleRefresh = async (params: ODataParams) => {

        const filter = params.filter ? `(${params.filter})` : undefined;

        return await client.client.getStudies(undefined, filter, params.orderby, undefined, params.top, params.skip, undefined, true);
    };

    return (
        <DocumentTitle title="Studies | Vitalograph Web Portal">
            <Query onRefresh={handleRefresh} initialOrdering={[{ field: "name", condition: "asc" }]}>
                <StudiesTable />
            </Query>
        </DocumentTitle>
    );
};
